module.exports = __webpack_public_path__ + "static/img/编组 5备份 6.2c3dba6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hz/编组 5备份 6.png
// module id = /+0P
// module chunks = 1